import { connect } from 'react-redux';
import { change } from 'redux-form';
import { getSelected } from '../utils/selection';
import PersuasionModalProvider from '../../common/context/PersuasionModalContext';
import SingleChoice from '../components/SingleChoice';
import ConfirmationModalProvider from '../../common/context/ConfirmationModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
const PersuasionModalWrapper = props => /*#__PURE__*/_jsx(PersuasionModalProvider, {
  children: /*#__PURE__*/_jsx(ConfirmationModalProvider, {
    children: /*#__PURE__*/_jsx(SingleChoice, {
      ...props
    })
  })
});
const mapStateToProps = (state, _ref) => {
  let {
    form,
    productName
  } = _ref;
  return {
    isSelected: getSelected(productName, form)(state)
  };
};
const mapDispatchToProps = (dispatch, _ref2) => {
  let {
    form,
    productName
  } = _ref2;
  return {
    setTravelerIds: value => dispatch(change(form, `${productName}.travelerIds`, value))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PersuasionModalWrapper);